import { useQuery } from "react-query";
import { getScorecardByCaseNumber } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

export const useGetScorecardByCaseNumber = (caseNumber) => {
  return useQuery(
    ["GetScorecardByCaseNumber", caseNumber],
    () => getScorecardByCaseNumber(caseNumber),
    { refetchOnWindowFocus: false }
  );
};
